import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import { TypedUseSelectorHook, createDispatchHook, createSelectorHook } from "react-redux";
import eventsSlice from "./eventsSlice";
import passiveMapperSlice from "./passiveMapperSlice";
import schedulablesSlice from "./schedulablesSlice";

export const ScheduleContext = React.createContext(null);

const scheduleStore = configureStore({
    reducer: {
        eventsStore: eventsSlice,
        schedulableStore: schedulablesSlice,
        passiveMapperStore: passiveMapperSlice,
    },
});
export default scheduleStore;

export type ScheduleState = ReturnType<typeof scheduleStore.getState>;
export type ScheduleDispatch = typeof scheduleStore.dispatch;
export const useScheduleSelector: TypedUseSelectorHook<ScheduleState> = createSelectorHook(ScheduleContext);
export const useScheduleDispatch = createDispatchHook<ScheduleDispatch>(ScheduleContext);
